import { SHIFT } from 'models/baselines';
import React, { useState } from 'react';
import { CompanyBaselineProps } from '../Baselines.types';

import styles from './CompanyBaseline.module.scss';

export const CompanyBaseline = ({
  periodIndex,
  companyIndex,
  companyName,
  night,
  day,
  onShiftUpdate
}: CompanyBaselineProps) => {
  const [nightValue, setNightValue] = useState(night);
  const [dayValue, setDayValue] = useState(day);

  return (
    <div key={companyName}>
      <div>
        <input
          data-testid="dayInput"
          className={styles.textInput}
          type="number"
          title={companyName}
          value={dayValue}
          onChange={(event) => {
            onShiftUpdate(
              periodIndex,
              companyIndex,
              Number(event.target.value),
              SHIFT.DAY
            );
            setDayValue(Number(event.target.value));
          }}
        />
      </div>
      <div>
        <input
          data-testid="nightInput"
          className={styles.textInput}
          type="number"
          title={companyName}
          value={nightValue}
          onChange={(event) => {
            onShiftUpdate(
              periodIndex,
              companyIndex,
              Number(event.target.value),
              SHIFT.NIGHT
            );
            setNightValue(Number(event.target.value));
          }}
        />
      </div>
      <div>
        <div className={styles.baselineItemCompanies}>
          <h1 className={styles.company}>{companyName}</h1>
        </div>
      </div>
    </div>
  );
};
